import React, { Component } from 'react'

import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp'
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker'
import bbox from 'geojson-bbox'

import Rainbow from 'rainbowvis.js'
import _ from 'lodash'
import { formatNumber } from '../../utils/utils'

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN

function getColorRamp(startColor, endColor, numberOfColors) {
  if (numberOfColors < 2) return [startColor]

  var rainbow = new Rainbow()

  rainbow.setNumberRange(1, numberOfColors)

  rainbow.setSpectrum(startColor, endColor)

  let colors = []

  for (var i = 1; i <= numberOfColors; i++) {
    colors.push(`#${rainbow.colourAt(i)}`)
  }
  return colors
}

export default class Map extends Component {

  constructor(props) {
    super(props)

    mapboxgl.workerClass = MapboxWorker
    mapboxgl.accessToken = MAPBOX_TOKEN

    this.state = {
      mapWidth: undefined,
      ssts: undefined,
      currentValues: undefined
    }
    
    this.mapContainer = React.createRef()
  }

  componentDidMount() {
    this.map = new mapboxgl.Map({
      container: this.mapContainer.current,
      style: 'mapbox://styles/joaogamboa/cknu8lqt50oyi17p65phgecrr',
      center: [ -8.3, 37.76],
      zoom: 8
    })

    this.map.scrollZoom.disable()

    this.map.on('load', async () => {
      await this.loadGeometries()
      this.processValues()
    })

  }

  componentDidUpdate(prevProps) {
    if (this.map) {
      if (this.mapContainer.current.clientWidth != this.state.mapWidth) {
        this.map.resize()
        this.setState({mapWidth: this.mapContainer.current.clientWidth})
      }
    }

    if (this.props.data != prevProps.data) {
      this.processValues()
    }
  }

  componentWillUnmount() {
    this.map.remove()
  }

  processValues() {
    if (!this.map || !this.props.data) return
    
    let values = {}
    _.chain(this.props.data).groupBy(v => v['sst']).map((arr, key) => {
      values[key] = _.sumBy(arr, 'consumptionTotal')
    }).value()

    
    // Object.entries(values).forEach(([sst, value]) => {
    //   values[sst] = Math.round(values[sst] / this.props.sstData.length)
    // })

    // Setup colors

    const colorRamp = getColorRamp('#009999', '#ff9000', Object.entries(values).length)

    Object.entries(values).sort((a,b) => a[1]-b[1]).map((sst, ix)=> { 
      values[sst[0]] = {
        value: sst[1],
        color: colorRamp[ix]
      }
    })

    Object.keys(values).forEach(sst => {
      this.map.setPaintProperty(sst, 'line-color', values[sst].color)
    })

    this.setState({currentValues: values})

  }

  render() {

    const mapScale = () => {
      // TODO CALCULATE BASED ON GEOMETRIES
    }

    return (
      <div className="section pb-3 pt-2">
        <div className="map-container" style={{position: 'relative'}}>

          {/* MAP */}
          <div ref={this.mapContainer} className="map"></div>

          {/* MAP TITLE */}
          <div style={{
            position: 'absolute',
            top: '5%',
            left: '3%',
            padding: '10px',
            background: 'rgba(255, 255, 255, 0.8)',
            marginRight: '20px',
            overflow: 'auto',
            borderRadius: '3px',
          }}>
            <p className='subtitle is-size-6'>Consumo por Subestação (MWh)</p>

          </div>

          {/* LEGEND CONTAINER */}
          <div style={{
            position: 'absolute',
            bottom: '10%',
            left: '3%',
            padding: '10px',
            background: 'rgba(255, 255, 255, 0.8)',
            marginRight: '20px',
            // fontFamily: 'Arial, sans-serif',
            overflow: 'auto',
            borderRadius: '3px',
          }}>

            {this.state.currentValues && 
              Object.keys(this.state.currentValues).map(k => [k, this.state.currentValues[k].value, this.state.currentValues[k].color]).sort((a,b) => b[1] - a[1]).map(v =>
                <div key={v[0]} style={{ marginBottom: '5px'}}>
                  <span style={{
                    display: 'inline-block',
                    borderRadius: '20%',
                    width: '10px',
                    height: '10px',
                    marginRight: '5px',
                   
                    backgroundColor: v[2]
                  }}>

                  </span>
                  {formatNumber(v[1], 0)} kWh
                </div>
              )

            }


          </div>
        </div>
      </div>
    )
  }

  async loadGeometries() {

    this.map.loadImage('geometries/station-sm.png', (error, img) => {
      this.map.addImage('station-symbol', img)
    })

    // ADD NETWORK

    const nwJson = await (await fetch('geometries/network.geojson', { headers : { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }})).json()

    this.map.addSource('network', {
      'type': 'geojson',
      'data': nwJson
    })
    this.map.addLayer({
      'id': 'network',
      'type': 'line',
      'source': 'network',
      'layout': {
        'line-join': 'round',
        'line-cap': 'round'
      },
      'paint': {
        'line-color': '#abb0b8',
        'line-width': 2
      }
    })

    // ADD SST

    const sstJson = await (await fetch('geometries/sst.geojson', { headers : { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }})).json()

    // Bounding box to fit the map
    const bb = bbox(sstJson) 
    bb[1] -= .02
    bb[3] += .02
    this.map.fitBounds(bb)

    // In order to be able to color the features dynamically
    // Each SST needs to be it's own layer

    const clonable = JSON.stringify(sstJson)
    const ssts = []
    sstJson.features.forEach(f => {
      // Create a new object
      const obj = JSON.parse(clonable)

      // Keep only this feature
      obj.features = [f]

      // SST name
      const sst = f.properties['sst']
      ssts.push(sst)

      // Add to map
      this.map.addSource(sst, {
        'type': 'geojson',
        'data': obj
      })
      this.map.addLayer({ 
        'id': sst,
        'type': 'line',
        'source': sst,
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        'paint': {
          'line-color': '#524f4e',
          'line-width': 6
        }
      })

      // Popup
      const sstPopup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
        className: `popup-${sst}`
      })

      this.map.on('mousemove', sst, e => {
        // this.map.getCanvas().style.cursor = 'pointer'

        var html = `<p><b>SST - ${sst}</b></p>`

        if (this.state.currentValues)
          html = html +  `
            <p>Consumo total no período:</p>
            <p>${formatNumber(this.state.currentValues[sst].value)} MWh</p>
          `
        
        sstPopup.setLngLat(e.lngLat).setHTML(html).addTo(this.map)
      })

      this.map.on('mouseleave', sst, e => {
        sstPopup.remove()
      })



    })


    this.setState({ssts: ssts})


    // ADD STATIONS

    const stationsJson = await (await fetch('geometries/stations.geojson', { headers : { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }})).json()

    this.map.addSource('stations', {
      'type': 'geojson',
      'data': stationsJson
    })
    this.map.addLayer({
      'id': 'stations',
      'type': 'symbol',
      'source': 'stations',
      'layout': {
        'icon-image': 'station-symbol',
        'icon-size': .3,
        'text-field': ['get', 'name'],
        'text-anchor': 'bottom-left',
        'text-size': 10,
        'text-offset': [1.1, 0],
        'icon-allow-overlap': true
      },
      'paint': {
        'text-color': '#808080',
        'text-halo-width': 2,
        'text-halo-color': 'white',
      }
    })

    // ADD SST LABELS

    const sstCentroidsJson = await (await fetch('geometries/sst-centroids.geojson', { headers : { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }})).json()

    this.map.addSource('centroids', {
      'type': 'geojson',
      'data': sstCentroidsJson
    })
    this.map.addLayer({
      'id': 'centroids',
      'type': 'symbol',
      'source': 'centroids',
      'layout': {
        'text-field': ['get', 'sst'],
        'text-anchor': 'bottom-left',
        'text-size': 14,
        'icon-allow-overlap': true
      },
      'paint': {
        'text-color': '#363636',
        'text-halo-width': 2,
        'text-halo-color': 'white',
      }
    })

    
    // return new Promise((resolve, reject) => {

    //   // ADD NETWORK
    //   fetch('geometries/network.geojson', { headers : { 
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    //   }}).then(res => {
    //     res.json().then(json => {
    //       this.map.addSource('network', {
    //         'type': 'geojson',
    //         'data': json
    //       })
    //       this.map.addLayer({
    //         'id': 'network',
    //         'type': 'line',
    //         'source': 'network',
    //         'layout': {
    //           'line-join': 'round',
    //           'line-cap': 'round'
    //         },
    //         'paint': {
    //           'line-color': '#abb0b8',
    //           'line-width': 2
    //         }
    //       })
    //     })
    //   })

    //   // ADD STATIONS

    //   this.map.loadImage('geometries/station-sm.png', (error, img) => {
    //     this.map.addImage('station-symbol', img)

    //     fetch('geometries/stations.geojson', { headers : { 
    //       'Content-Type': 'application/json',
    //       'Accept': 'application/json'
    //     }}).then(res => {
    //       res.json().then(json => {
    //         this.map.addSource('stations', {
    //           'type': 'geojson',
    //           'data': json
    //         })
    //         this.map.addLayer({
    //           'id': 'stations',
    //           'type': 'symbol',
    //           'source': 'stations',
    //           'layout': {
    //             'icon-image': 'station-symbol',
    //             'icon-size': .3,
    //             'text-field': ['get', 'name'],
    //             'text-anchor': 'bottom-left',
    //             'text-size': 10,
    //             'text-offset': [1.1, 0],
    //             'icon-allow-overlap': true
    //           },
    //           'paint': {
    //             'text-color': '#808080',
    //             'text-halo-width': 2,
    //             'text-halo-color': 'white',
    //           }
    //         })
    //       })
    //     })
    //   })

    //   // ADD SST LABELS



    //   // this.map.loadImage('geometries/station-sm.png', (error, img) => {
    //   //   this.map.addImage('station-symbol', img)



    //   //   fetch('geometries/network.geojson', { headers : { 
    //   //     'Content-Type': 'application/json',
    //   //     'Accept': 'application/json'
    //   //   }}).then(res => {
    //   //     res.json().then(json => {
    //   //       this.map.addSource('network', {
    //   //         'type': 'geojson',
    //   //         'data': json
    //   //       })
    //   //       this.map.addLayer({
    //   //         'id': 'network',
    //   //         'type': 'line',
    //   //         'source': 'network',
    //   //         'layout': {
    //   //           'line-join': 'round',
    //   //           'line-cap': 'round'
    //   //         },
    //   //         'paint': {
    //   //           'line-color': '#abb0b8',
    //   //           'line-width': 2
    //   //         }
    //   //       })
    //   //     })
    //   //   }).then(() => {
  
    //       fetch('geometries/sst_anal.geojson', { headers : { 
    //         'Content-Type': 'application/json',
    //         'Accept': 'application/json'
    //       }}).then(res => {
    //         res.json().then(json => {

    //           console.log(json)


    //           this.setState({sstGeojson: json})
    //           this.map.addSource('sst', {
    //             'type': 'geojson',
    //             'data': json
    //           })
    //           this.map.addLayer({ 
    //             'id': 'sst',
    //             'type': 'line',
    //             'source': 'sst',
    //             'layout': {
    //               'line-join': 'round',
    //               'line-cap': 'round'
    //             },
    //             'paint': {
    //               'line-color': '#009999',
    //               'line-width': 2
    //             }
    //           })
            
    //           const bb = bbox(json) 
    //           bb[1] -= .02
    //           bb[3] += .02
    //           this.map.fitBounds(bb)
    //         })
    //       })
    //     })
    //     // .then(() => {
  
    //     //   fetch('geometries/stations.geojson', { headers : { 
    //     //     'Content-Type': 'application/json',
    //     //     'Accept': 'application/json'
    //     //   }}).then(res => {
    //     //     res.json().then(json => {
    //     //       this.map.addSource('stations', {
    //     //         'type': 'geojson',
    //     //         'data': json
    //     //       })
    //     //       this.map.addLayer({
    //     //         'id': 'stations',
    //     //         'type': 'symbol',
    //     //         'source': 'stations',
    //     //         'layout': {
    //     //           'icon-image': 'station-symbol',
    //     //           'icon-size': .3,
    //     //           'text-field': ['get', 'name'],
    //     //           'text-anchor': 'bottom-left',
    //     //           'text-size': 10,
    //     //           'text-offset': [1.1, 0],
    //     //           'icon-allow-overlap': true
    //     //         },
    //     //         'paint': {
    //     //           'text-color': '#808080',
    //     //           'text-halo-width': 2,
    //     //           'text-halo-color': 'white',
    //     //         }
    //     //       })
    //     //     })
    //     //   })
    //     // }).then(() => {  
    //       fetch('geometries/sst-centroids.geojson', { headers : { 
    //         'Content-Type': 'application/json',
    //         'Accept': 'application/json'
    //       }}).then(res => {
    //         res.json().then(json => {
    //           this.map.addSource('centroids', {
    //             'type': 'geojson',
    //             'data': json
    //           })
    //           this.map.addLayer({
    //             'id': 'centroids',
    //             'type': 'symbol',
    //             'source': 'centroids',
    //             'layout': {
    //               'text-field': ['get', 'sst'],
    //               'text-anchor': 'bottom-left',
    //               'text-size': 14,
    //               'icon-allow-overlap': true
    //             },
    //             'paint': {
    //               'text-color': '#009999',
    //               'text-halo-width': 2,
    //               'text-halo-color': 'white',
    //             }
    //           })
    //           return resolve()
    //         })
    //       })
    //     // })
    //   // })
    // // })
  }

}
